"use strict";
/* eslint-disable no-shadow */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IoTDeviceDirection = exports.IotOutputFunction = exports.IotDeviceFunction = exports.IotDeviceType = exports.IotInputFunction = exports.IotInputType = exports.SessionEventSensorType = exports.SessionState = exports.SettingDataType = exports.SettingType = exports.DayOfWeek = exports.LocationType = void 0;
var LocationType;
(function (LocationType) {
    LocationType["LEID"] = "LEID";
    LocationType["FRANCHISE"] = "FRANCHISE";
    LocationType["RE_RENTER"] = "RE_RENTER";
    LocationType["SAAS"] = "SAAS";
})(LocationType = exports.LocationType || (exports.LocationType = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var SettingType;
(function (SettingType) {
    SettingType["INCLUDE_VAT_IN_PRICE"] = "INCLUDE_VAT_IN_PRICE";
})(SettingType = exports.SettingType || (exports.SettingType = {}));
var SettingDataType;
(function (SettingDataType) {
    SettingDataType["BOOLEAN"] = "BOOLEAN";
    SettingDataType["NUMBER"] = "NUMBER";
    SettingDataType["STRING"] = "STRING";
})(SettingDataType = exports.SettingDataType || (exports.SettingDataType = {}));
var SessionState;
(function (SessionState) {
    SessionState["ARRIVED"] = "ARRIVED";
    SessionState["DEPARTED"] = "DEPARTED";
    SessionState["UNKNOWN"] = "UNKNOWN";
    SessionState["UNSTABLE_ARRIVED"] = "UNSTABLE_ARRIVED";
    SessionState["UNSTABLE_DEPARTED"] = "UNSTABLE_DEPARTED";
})(SessionState = exports.SessionState || (exports.SessionState = {}));
var SessionEventSensorType;
(function (SessionEventSensorType) {
    SessionEventSensorType["RFID"] = "RFID";
    SessionEventSensorType["GPS"] = "GPS";
})(SessionEventSensorType = exports.SessionEventSensorType || (exports.SessionEventSensorType = {}));
var IotInputType;
(function (IotInputType) {
    IotInputType["DOOR_STATE"] = "DoorState";
    IotInputType["LOCK_STATE"] = "LockState";
    IotInputType["MOVEMENT_SENSOR"] = "MovementSensor";
})(IotInputType = exports.IotInputType || (exports.IotInputType = {}));
var IotInputFunction;
(function (IotInputFunction) {
    IotInputFunction["RFID"] = "RFID";
    IotInputFunction["SCANNER"] = "Scanner";
    IotInputFunction["DIGITAL_IO"] = "Digital.IO";
})(IotInputFunction = exports.IotInputFunction || (exports.IotInputFunction = {}));
var IotDeviceType;
(function (IotDeviceType) {
    IotDeviceType["RFID"] = "RFID";
    IotDeviceType["RECORDING"] = "Recording";
    IotDeviceType["DIGITAL_IO"] = "Digital-IO";
    IotDeviceType["CAMERA"] = "Camera";
    IotDeviceType["DOOR"] = "Door";
    IotDeviceType["ADAM6066"] = "ADAM6066";
})(IotDeviceType = exports.IotDeviceType || (exports.IotDeviceType = {}));
var IotDeviceFunction;
(function (IotDeviceFunction) {
    IotDeviceFunction["RFID"] = "RFID";
    IotDeviceFunction["RECORDING"] = "Recording";
    IotDeviceFunction["DIGITAL_IO"] = "Digital-IO";
    IotDeviceFunction["CAMERA"] = "Camera";
    IotDeviceFunction["DOOR"] = "Door";
})(IotDeviceFunction = exports.IotDeviceFunction || (exports.IotDeviceFunction = {}));
var IotOutputFunction;
(function (IotOutputFunction) {
    IotOutputFunction["DOOR"] = "Door";
    IotOutputFunction["LIGHT"] = "Light";
})(IotOutputFunction = exports.IotOutputFunction || (exports.IotOutputFunction = {}));
var IoTDeviceDirection;
(function (IoTDeviceDirection) {
    IoTDeviceDirection["IN"] = "IN";
    IoTDeviceDirection["OUT"] = "OUT";
    IoTDeviceDirection["BOTH"] = "BOTH";
})(IoTDeviceDirection = exports.IoTDeviceDirection || (exports.IoTDeviceDirection = {}));
